import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/esm/Col';

function OrganizerCard({
  organizer,
  chosenOrganizerId,
  chosenOrganizer,
  onActivate,
  onInactivate,
  onEdit,
}) {
  return (
    <Card>
      <Card.Body>
        <Col
          className={
            organizer?.isActive
              ? 'd-flex flex-column'
              : 'd-flex flex-column inactive-tr'
          }
        >
          <div className='d-flex align-items-center'>
            <h3>{organizer?.clubName}</h3>
          </div>
          <div className='d-flex bg-divider align-items-center justify-content-between'>
            <span>Klubbadministratör</span>
            <span>{organizer?.email}</span>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <span>Org.nr</span>
            <span>{organizer?.organizationNumber}</span>
          </div>
          <div className='d-flex bg-divider align-items-center justify-content-between'>
            <span>Distrikt</span>
            <span>{organizer?.district}</span>
          </div>
        </Col>

        <Card.Footer className='mt-4'>
          <div className='d-flex gap-5 align-items-center justify-content-between'>
            {organizer?.isActive ? (
              <div
                className='d-flex gap-2 justify-content-end'
                role='button'
                onClick={() => {
                  chosenOrganizerId(organizer?.id);
                  onInactivate();
                }}
              >
                <span className='material-symbols-outlined'>
                  do_not_disturb_on
                </span>
                <span>Inaktivera</span>
              </div>
            ) : (
              <div
                className='d-flex gap-2 justify-content-end'
                role='button'
                onClick={() => {
                  chosenOrganizerId(organizer?.id);
                  onActivate();
                }}
              >
                <span className='material-symbols-outlined'>add_circle</span>
                <span>Aktivera</span>
              </div>
            )}
            <Button
              variant='outline-primary'
              className='py-0 px-3'
              disabled={!organizer.isActive}
              onClick={() => {
                chosenOrganizer(organizer);
                onEdit();
              }}
            >
              Redigera
            </Button>
          </div>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}

export default OrganizerCard;
